import React from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { email, required, password } from 'Utils/FormValidation';
import { SubmitButton } from 'Components/Fields/Buttons';
import './SignIn.css';
import { useForm } from 'Hooks/useForm';
import { FormField } from 'Components/HookFormFields/FormField';
import { getFeatureFlag } from 'Utils/FeatureFlags';

const SignInForm = ({ onFormSubmit, defaultEmailValue }) => {
  const formName = 'signInForm';
  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
    initialValues: { email: defaultEmailValue || '' },
    onFormCompletedTrackingFields: () => ({ 'Social Network': '' }),
  });

  // for testing the feature flag debugging page (NATCOM-905) in QA env only
  const submitBtnText = getFeatureFlag('featureFlag_test') ? 'Sign in now' : 'Sign in';

  return (
    <form onSubmit={handleSubmit} name={formName} className="signInForm">
      <section className="formInput">
        <FormField
          name="email"
          label="Email Address"
          component="EmailField"
          validate={[required, email]}
          validateOnBlur={[email]}
          validateDebounceTime={600}
          {...formFieldProps}
        />
        <FormField
          name="password"
          label="Password"
          component="PasswordField"
          validate={[required, password]}
          validateOnBlur={[password]}
          validateDebounceTime={600}
          type="password"
          {...formFieldProps}
        />
      </section>
      <SubmitError error={formError} formName={formName} />
      <SubmitButton text={submitBtnText} isDisabled={submitDisabled} submitting={submitting} />
    </form>
  );
};

export default SignInForm;
